import React, { useEffect, useRef, memo } from 'react';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { ContentLoader, NotFound, Link, SafeHTML } from '../common';
import { WordPressPost, HTMLPosts } from '../../types';

interface RepeaterProps {
  posts: WordPressPost[];
  htmlPosts: HTMLPosts;
  page: number;
  totalPages: number;
  loading: boolean;
  setPage: (page: number) => void;
  setShowTop: (show: boolean) => void;
  handleChangePage: (event: React.ChangeEvent<unknown>, value: number) => void;
}

const Repeater: React.FC<RepeaterProps> = memo(
  ({ posts, htmlPosts, page, totalPages, loading, setPage, setShowTop, handleChangePage }) => {
    const contentDivRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      if (page !== 1 || contentDivRef.current) {
        setShowTop(true);
      }
    }, [page, setShowTop]);

    if (loading) {
      return <ContentLoader />;
    }

    if (!page || posts.length === 0) {
      return <NotFound />;
    }

    return (
      <div id={page.toString()} ref={contentDivRef}>
        <SafeHTML className="row blog-index-posts" html={htmlPosts.__html} />
        {posts.length > 0 && totalPages > 1 && (
          <div
            className="blog-index-paginator"
            style={{
              alignItems: 'center',
              display: 'flex',
              borderRadius: '16px',
              justifyContent: 'center',
            }}
          >
            <span>Page: </span>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handleChangePage}
              shape="rounded"
              renderItem={(item) => {
                const linkProps = {
                  href: `?page=${item.page}`,
                  onChange: (e: React.MouseEvent, page: string | null) => {
                    if (page) {
                      handleChangePage(e as any, parseInt(page));
                    }
                  },
                };
                return <PaginationItem component={Link as any} {...linkProps} {...item} />;
              }}
            />
          </div>
        )}
      </div>
    );
  }
);

// Add display name for debugging
Repeater.displayName = 'Repeater';

export default Repeater;
